import { defineMessages } from 'react-intl';

export default defineMessages({
	pageTitle: {
		id: 'dev-agents.not-found.page-title',
		defaultMessage: 'Not found',
		description: 'Message displayed when a requested page cannot be found',
	},
});
